import { render } from "./popupOverlay.vue?vue&type=template&id=2b668431"
import script from "./popupOverlay.vue?vue&type=script&lang=js"
export * from "./popupOverlay.vue?vue&type=script&lang=js"

import "./popupOverlay.vue?vue&type=style&index=0&id=2b668431&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__